type GetDeviceContextOptions = {
  innerHeight: number;
  innerWidth: number;
  navigator: Navigator;
  screen: Screen;
};

/**
 * @link https://develop.sentry.dev/sdk/data-model/event-payloads/contexts/#device-context
 * @param {Navigator} navigator
 * @returns {Object}
 */
export const getDeviceContext = ({
  innerHeight,
  innerWidth,
  navigator,
  screen,
}: GetDeviceContextOptions) => {
  let deviceName = 'Unknown';
  let manufacturer = 'Unknown';
  const model = navigator.userAgent;
  const screenResolution = `${screen.width}x${screen.height}`;
  const iframeResolution = `${innerWidth}x${innerHeight}`;
  const language = navigator.language;
  const onlineStatus = navigator.onLine;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Modern browsers with userAgentData
  if (navigator.userAgentData) {
    const platform = navigator.userAgentData.platform || 'Unknown';
    const brands = navigator.userAgentData.brands || [];

    deviceName = platform;
    manufacturer = brands.map((b) => b.brand).join(', ') || 'Unknown';
  } else {
    // Fallback for older browsers using userAgent
    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('windows')) {
      deviceName = 'Windows';
    } else if (userAgent.includes('iphone') || userAgent.includes('ipad')) {
      deviceName = 'iOS';
    } else if (userAgent.includes('mac os x')) {
      deviceName = 'MacOS';
    } else if (userAgent.includes('linux')) {
      deviceName = 'Linux';
    } else if (userAgent.includes('android')) {
      deviceName = 'Android';
    }

    // Manufacturer (rough heuristic based on userAgent)
    if (userAgent.includes('samsung')) {
      manufacturer = 'Samsung';
    } else if (userAgent.includes('huawei')) {
      manufacturer = 'Huawei';
    } else if (userAgent.includes('google')) {
      manufacturer = 'Google';
    } else if (userAgent.includes('apple')) {
      manufacturer = 'Apple';
    }
  }

  return {
    'IFrame Height Pixels': innerHeight,
    'IFrame Resolution': iframeResolution,
    'IFrame Width Pixels': innerWidth,
    language,
    manufacturer,
    model,
    name: deviceName,
    online: onlineStatus,
    screen_resolution: screenResolution,
    timezone,
  };
};
